import { useQuery } from "@tanstack/react-query";
import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { customInputsQuery } from "#modules/quoteRequestLines/infra/customInputs.query";

export type CustomInputsDto = ClientInferResponseBody<
  typeof contract.quoteRequestLines.customInputs
>;

export const useCustomInputs = (options?: { enabled?: boolean }) => {
  const { data, ...rest } = useQuery({ ...customInputsQuery(), ...options });

  return { customInputs: data ?? [], ...rest };
};
